import { render, staticRenderFns } from "./DeleteDriverModal.vue?vue&type=template&id=cb87b89c&scoped=true&"
import script from "./DeleteDriverModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDriverModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb87b89c",
  null
  
)

export default component.exports